// extracted by mini-css-extract-plugin
export default {"favorites":"style_favorites__OoXmU","favorites__list_wrapper":"style_favorites__list_wrapper__WH9y0","favorites__types":"style_favorites__types__FTiRw","card":"style_card__A8Pue"};